var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.028 27.769A13.954 13.954 0 0 0 30 17.999c0-7.732-6.268-14-14-14S2 10.268 2 18c0 3.848 1.552 7.333 4.065 9.864 1.64-1.567 5.469-4.106 9.935-4.106 4.377 0 8.252 2.438 10.028 4.01zm-6.452-17.285a3.455 3.455 0 1 1-6.91 0 3.455 3.455 0 0 1 6.91 0zm-3.515 1.879a1.818 1.818 0 1 0 0-3.637 1.818 1.818 0 0 0 0 3.637z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnt);
export default __webpack_public_path__ + "static/media/PNT.7b0b4b8f3474da3f509571e643b34d1d.svg";
export { ForwardRef as ReactComponent };